import createReducer from 'utils/redux/createReducer'
import * as R from 'ramda'

const initialState = {
	repairmen: {}
}

export default createReducer(initialState, {
	PROJECT_REPAIRMAN_CHECK: (currentState, action) => {
		return ({
		repairmen:  (R.values(R.filter(R.propEq('repairmanID', action.data.repairmanID), currentState.repairmen)).length)?
				R.reject(
					  R.propEq('repairmanID', action.data.repairmanID)
					, currentState.repairmen
				  )
				:
				{
					...currentState.repairmen
				  , [action.data._id]: {
						...action.data
				}
				}

		})
	}
  , CLOSE_REPAIRMEN_SELECT: (currentState, action) => ({
	  repairmen: {}
  })
  , PROJECT_REPAIRMEN_OK: (currentState, action) => ({
	  repairmen: {}
  })
})



// WEBPACK FOOTER //
// ./src/reducers/repairmenSelect.js